export const GRAPHICS_DELIVERY_FILTERS = [
  { text: 'Sent for Approval', matchStatuses: ['Sent for Approval', 'Internal Approved'] },
  { text: 'Approved', matchStatuses: ['Approved'] },
  { text: 'Partner Revision', matchStatuses: ['Partner Revision', 'Re-Work'] },
  { text: 'Moved to Assets Gallery', matchStatuses: ['Moved to Assets Gallery'] },
  { text: 'All', matchStatuses: null },
];

export const DOCUMENT_DELIVERY_FILTERS = [
  { text: 'Sent for Approval', matchStatuses: ['Sent for Approval', 'Internal Approved'] },
  { text: 'Approved', matchStatuses: ['Approved'] },
  { text: 'Re-Work', matchStatuses: ['Re-Work', 'Partner Revision'] },
  { text: 'Moved to Assets Gallery', matchStatuses: ['Moved to Assets Gallery'] },
  { text: 'All', matchStatuses: null },
];

export const matchesDeliveryStatus = (statusText, filterText, filterConfig) => {
  if (filterText === 'All') return true;
  const filter = filterConfig.find((item) => item.text === filterText);
  if (!filter || !filter.matchStatuses) return statusText === filterText;
  return filter.matchStatuses.includes(statusText);
};

export const getDeliveryStatusCount = (statusCountMap, filterText, filterConfig, total) => {
  if (filterText === 'All') {
    return total != null
      ? total
      : Object.values(statusCountMap || {}).reduce((sum, count) => sum + count, 0);
  }
  const filter = filterConfig.find((item) => item.text === filterText);
  if (!filter || !filter.matchStatuses) return (statusCountMap && statusCountMap[filterText]) || 0;
  return filter.matchStatuses.reduce(
    (sum, status) => sum + ((statusCountMap && statusCountMap[status]) || 0),
    0
  );
};

export const assetsHaveDeliveryStatus = (assets, filterText, filterConfig) => {
  const filter = filterConfig.find((item) => item.text === filterText);
  if (!filter || !filter.matchStatuses) return false;
  return (assets || []).some((asset) => filter.matchStatuses.includes(asset.statusText));
};

export const getDeliveryStatusDisplay = (statusText) => {
  if (statusText === 'Internal Approved') return 'Sent for Approval';
  return statusText || '';
};

export const isPartnerApprovedStatus = (status, statusText) =>
  statusText === 'Approved' || Number(status) === 5 || Number(status) === 16;
